<template>
  <div>
    <subscription-modal ref="subscription" :subscription-id="selectedSubscriptionId" :show.sync="showSubscriptionModal"></subscription-modal>

    <loading v-model="loading" :height="300">
      <div class="table-fix-head table-height-300">
        <table class="table table-light">
          <thead>
            <tr>
              <th scope="col" class="p-2 pb-3" v-if="!table$hiddenColumns.has('name')">
                Vásárlás
              </th>
              <th scope="col" class="p-2 pb-3" v-if="!table$hiddenColumns.has('dates')">
                Időpont
              </th>
              <th scope="col" class="p-2 pb-3" v-if="!table$hiddenColumns.has('package')">
                Csomag
              </th>
              <th scope="col" class="p-2 pb-3" v-if="!table$hiddenColumns.has('price')">
                Ár
              </th>
              <th scope="col" class="text-right p-2 pb-3" v-if="!table$hiddenColumns.has('actions')">
                Műveletek
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(purchase, index) in purchases"
              :key="`p${index}`"
            >
              <td class="p-2" v-if="!table$hiddenColumns.has('id')">
                <span class="badge badge-secondary">#{{ purchase.id }}</span>
                <span class="ml-2">
                  <purchase-label :show-link="!table$hiddenColumns.has('subscription_link')" :purchase="purchase" @subscription-clicked="selectedSubscriptionId = $event"></purchase-label>
                  <span v-if="purchase.is_trial" class="badge badge-success ml-2">Próbaidőszak</span>
                </span>
              </td>
              <td class="p-2" v-if="!table$hiddenColumns.has('dates')">
                <div class="small">Vásárlás: {{ displayFormatDate(purchase.created_at) }}</div>
                <div class="small">Felhasználható ettől: {{ displayFormatDate(purchase.validity_start) }}</div>
                <div class="small">Felhasználható eddig: {{ displayFormatDate(purchase.validity_end) }}</div>
              <td class="p-2" v-if="!table$hiddenColumns.has('package')">
                {{ purchase.package.name }}
                <span v-if="purchase.package.is_recurring" class="badge badge-info ml-2">Ismétlődő</span>
              </td>
              <td class="p-2" v-if="!table$hiddenColumns.has('price')">
                {{ purchase.price }} Ft
              </td>
              <td class="p-2 text-right" v-if="!table$hiddenColumns.has('actions')">
                <b-button-group size="sm">
                  <b-button variant="danger" size="sm" @click="deletePurchase(purchase, index)">
                    Törlés
                  </b-button>
                </b-button-group>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </loading>
  </div>
</template>
<style lang="scss">
</style>
<script>
import moment from 'moment'
import Loading from '../common/LoadingPlaceholder'
import { displayFormatDate } from '../../utils/Date'
import PurchaseLabel from './partials/PurchaseLabel'
import TableHelper from '../../utils/mixins/TableHelper'

export default {
  mixins: [
    TableHelper('purchases', 'id', {
      customerId: {
        type: Number,
        required: false,
        default: -1
      },
      subscriptionId: {
        type: Number,
        required: false,
        default: -1,
      },
    }, 'api.billing-purchases.index')
  ],
  components: {
    'loading': Loading,
    'purchase-label': PurchaseLabel
  },
  data() {
    return {
      showModal: false,
      selectedSubscriptionId: -1,
      loading: true,
      purchases: [],
    }
  },
  computed: {
    showSubscriptionModal: {
      get() {
        return this.selectedSubscriptionId !== -1
      },
      set(shown) {
        if(!shown) {
          this.selectedSubscriptionId = -1
        }
      }
    }
  },
  mounted() {
    this.$root.$on('purchase', this.addPurchase.bind(this))
  },
  methods: {
    deletePurchase(purchase, index) {
      this.$bvModal.msgBoxConfirm(`Biztosan törölni szeretnéd ezt a vásárlást?`, {
      title: 'Megerősítés',
      okVariant: 'danger',
      okTitle: 'Igen',
      cancelTitle: 'Mégsem'
    }).then(value => {
      if(value) {
        this.$http.delete(this.$url('api.billing-purchases.destroy', purchase.id))
          .then(() => {
            this.purchases.splice(index, 1)
          })
          .catch(() => {
            this.$bvToast.toast('Hiba történt a művelet végrehajtása közben!', {
              title: 'Hiba',
              variant: 'danger'
            })
          })
      }
    })
    },
    addPurchase({purchase}) {
      this.purchases.push(purchase)
    },
    displayFormatDate
  }
}
</script>